import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/moving-and-storage-discounts.jpg'),
    alt: 'moving and storage discounts page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'moving and storage discounts page search image',
    width: 92,
    height: 92
  },

  ...ogImages
]

export const heroSectionContent = {
  title: 'Moving and <span>Storage</span><span>Discounts with ShipAndStorage</span>',
  description:
    'Explore exceptional moving and storage discounts at ShipAndStorage. Enjoy affordable rates, secure services, flexible plans for diverse needs, and quick shipping options tailored to personal and business requirements.',
  points: [
    'Affordable moving and storage rates',
    'Secure and dependable storage solutions',
    'Flexible plans for diverse moving needs',
    'Quick and efficient shipping options'
  ],
  image: {
    url: '/images/v2/pages/landing-pages/moving-and-storage-discounts/hero-image.svg',
    alt: 'moving and storage discounts page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up' }
}

export const helperGuideSection = {
  title: 'How ShipAndStorage Works',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.HOW_SHIP_AND_STORAGE_WORKS.href, text: 'Learn More' },

  cards: [
    {
      id: 1,
      title: 'Request a Quote',
      description:
        'Submit your details online to receive a customized quote that includes moving and storage discounts. Our team analyzes your requirements to offer a tailored solution that combines affordability, reliability, and secure storage.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/request-a-quote.svg',
        alt: 'Request a Quote service'
      }
    },
    {
      id: 2,
      title: 'Pack and Store',
      description:
        'We provide quality packing materials and secure storage facilities for your items. Whether you need short-term or long-term storage, our options come with significant moving and storage discounts to make storing your belongings easier and more cost-effective.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/pack-and-store.svg',
        alt: 'Pack and Store service'
      }
    },
    {
      id: 3,
      title: 'Ship or Retrieve',
      description:
        'With ShipAndStorage, you can choose to ship or retrieve your items as needed. We offer reliable delivery services and flexible retrieval options at discounted rates, making your experience convenient and budget-friendly.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/ship-or-retrieve.svg',
        alt: 'Ship or Retrieve service'
      }
    },
    {
      id: 4,
      title: 'Get Moving & Storage Discounts Now',
      description:
        'Unlock amazing moving and storage discounts with ShipAndStorage today! Experience affordable rates, reliable services, and flexible plans tailored to your needs. Don’t miss out on these exceptional savings—get started now!',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/get-moving-storage-discounts-now.svg',
        alt: 'Get Moving & Storage Discounts Now service'
      }
    }
  ]
}

export const whyStorageSectionContent = {
  title: 'Why Storage Service Is Necessary',

  cards: [
    {
      id: 1,
      title: 'Space Optimization',
      description:
        'Managing your space efficiently can be a challenge, especially when you have excess belongings or seasonal items. ShipAndStorage’s secure storage solutions provide the perfect way to free up valuable space at home or work. With our moving and storage discounts, you get extra storage without breaking the bank.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/space-optimization.svg',
        alt: 'Space Optimization service'
      }
    },
    {
      id: 2,
      title: 'Flexible Moving Solutions',
      description:
        "Temporary storage plays a crucial role during relocation or renovation. Whether you’re in the middle of a big move or upgrading your current space, our services offer the flexibility you need. With our moving and storage discounts, you can store items safely until you're ready to retrieve them.",
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/flexible-moving-solutions.svg',
        alt: 'Flexible Moving Solutions service'
      }
    },
    {
      id: 3,
      title: 'Cost Efficiency',
      description:
        'Storage costs can add up quickly, but ShipAndStorage’s moving and storage discounts help you maintain a budget-friendly approach. Our affordable rates cater to both short-term and long-term storage needs, ensuring a seamless experience without high costs.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/cost-efficiency.svg',
        alt: 'Cost Efficiency service'
      }
    }
  ]
}

export const gridSectionContent = {
  title: 'Who Chooses ShipAndStorage Service',

  cards: [
    {
      id: 1,
      title: 'Homeowners',
      description:
        'Homeowners who are looking to de-clutter or renovate often require temporary storage. ShipAndStorage provides secure and flexible options with moving and storage discounts, ensuring homeowners can manage their belongings easily during these transitions.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/homeowners.svg',
        alt: 'Homeowners'
      }
    },
    {
      id: 2,
      title: 'Business Owners',
      description:
        'Business owners often need additional space for documents, equipment, or inventory. Our affordable and secure storage solutions, combined with moving and storage discounts, provide an ideal way to keep business assets safe and accessible.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/business-owners.svg',
        alt: 'Business Owners'
      }
    },
    {
      id: 3,
      title: 'Frequent Travelers',
      description:
        'Frequent travelers benefit from our secure storage and shipping services, especially for luggage or personal belongings. Our discounted rates make it convenient for travelers to store their items safely and retrieve them whenever needed.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/frequent-travelers.svg',
        alt: 'Frequent Travelers'
      }
    },
    {
      id: 4,
      title: 'Students',
      description:
        'Students often need temporary storage for their belongings during semester breaks or relocations. ShipAndStorage offers affordable, flexible plans with moving and storage discounts, making it a popular choice for students on the go.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/students.svg',
        alt: 'Students'
      }
    },
    {
      id: 5,
      title: 'Military Personnel',
      description:
        'Military personnel face frequent relocations and often require temporary storage for personal items. With ShipAndStorage’s moving and storage discounts, military families can store belongings safely and retrieve them as needed during deployments.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/military-personnel.svg',
        alt: 'Military Personnel'
      }
    },
    {
      id: 6,
      title: 'Renters',
      description:
        'Renters who are transitioning between leases or moving to new locations can benefit from our flexible short-term storage options. ShipAndStorage’s moving and storage discounts make it an ideal choice for renters seeking secure and budget-friendly solutions.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/renters.svg',
        alt: 'Renters'
      }
    }
  ]
}

export const evenOddList = {
  title: 'Our Different Storage Services For You',

  articles: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Businesses need secure and accessible storage for documents, equipment, and inventory. ShipAndStorage offers cost-effective business storage solutions with moving and storage discounts, ensuring safe and organized handling of business assets.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/business-storage-solution.svg',
        alt: 'Business Storage Solution'
      },
      link: {
        text: 'Explore Business Storage',
        href: PUBLIC_MAIN_ROUTES.BUSINESS_STORAGE.href
      }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Moving can be stressful, but ShipAndStorage makes it simpler with our dedicated moving storage solutions. We provide temporary storage during moves, offering secure, hassle-free options that include substantial moving and storage discounts to help ease the process.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/moving-storage-solution.svg',
        alt: 'Moving Storage Solution'
      },
      link: {
        text: 'Explore Moving Storage',
        href: PUBLIC_MAIN_ROUTES.MOVING_STORAGE_SOLUTIONS.href
      }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        'Whether you’re traveling or relocating, our luggage and box shipping services ensure your belongings are safely shipped to their destination. Our solutions are designed to be convenient, and our moving and storage discounts make them highly affordable.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/luggage-and-box-shipping-services.svg',
        alt: 'Luggage and Box Shipping Services'
      },
      link: {
        text: 'Explore Luggage & Box Shipping',
        href: PUBLIC_MAIN_ROUTES.LUGGAGE_BOX_SHIPPING_SERVICES.href
      }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Residential storage needs vary from downsizing to decluttering, and ShipAndStorage caters to all with flexible storage options. Our services ensure secure storage for personal belongings, all while offering moving and storage discounts to keep it cost-effective.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/residential-storage-services.svg',
        alt: 'Residential Storage Services'
      },
      link: {
        text: 'Explore Residential Storage',
        href: PUBLIC_MAIN_ROUTES.RESIDENTIAL_STORAGE.href
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose ShipAndStorage for Shipping Needs?',

  cards: [
    {
      id: 1,
      title: 'Reliable and Safe Solutions',
      description:
        'We provide trusted, secure shipping and storage services tailored to your needs. With our moving and storage discounts, you can be assured of reliable service that meets both your budget and requirements.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/reliable-and-safe-solutions.svg',
        alt: 'Reliable and Safe Solutions'
      }
    },
    {
      id: 2,
      title: 'Transparent Pricing',
      description:
        'ShipAndStorage offers clear, upfront pricing with no hidden fees. Our moving and storage discounts ensure that you receive the best value for your money, making it easier to manage your budget.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/transparent-pricing.svg',
        alt: 'Transparent Pricing'
      }
    },
    {
      id: 3,
      title: 'Flexible Options',
      description:
        'Our services are designed to adapt to individual needs, whether for personal or business use. With a range of flexible plans and moving and storage discounts, you can choose options that work best for you.',
      image: {
        src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/flexible-options.svg',
        alt: 'Flexible Options'
      }
    }
  ]
}

export const infoBannerSectionContent = {
  id: 1,
  title: 'Get Moving And Storage Discounts Now Available',
  description:
    'Get moving and storage discounts today. Affordable, fast, and secure services to store and move your belongings efficiently.',
  image: {
    src: '/images/v2/pages/landing-pages/moving-and-storage-discounts/get-moving-and-storage-discounts-now-available.svg',
    alt: 'Get Moving And Storage Discounts Now Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Started' }
}

export const faqSectionContent = {
  title: 'Our Shipping Partners',
  description:
    'ShipAndStorage offers world-class Shipping and Storage Services in collaboration with trusted global carriers like FedEx, DHL, and UPS.',

  questions: [
    {
      id: 1,
      question: 'FedEx',
      answer:
        'Founded by Frederick W. Smith in 1971, FedEx started with just 186 packages and has grown into a global leader in shipping services. Today, FedEx operates a vast fleet of 696 aircraft and 215,000 vehicles, processing 16 million shipments daily to over 220 countries and territories. With more than 550,000 employees and over 5,000 centers worldwide, FedEx guarantees reliable and timely deliveries.|||Disclaimer|||This page was last updated in September 2024 for reference purposes only. FedEx makes no warranties, express or implied, regarding the accuracy or completeness of the information provided.|||For more details, visit FedEx.com. FedEx® is a registered trademark. © 1995-2024 FedEx'
    },

    {
      id: 2,
      question: 'DHL',
      answer:
        'DHL Express, a prominent division of Deutsche Post DHL Group, is renowned for its international courier, parcel, and express mail services. As a global leader in logistics, DHL handles over 1.8 billion parcels each year. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became fully owned by Deutsche Post in 2002 and now operates in over 220 countries, ensuring its vital role in the global supply chain.|||Disclaimer:|||This page was last updated in September 2024 and is provided for reference purposes only. DHL makes no warranties regarding the accuracy of the information provided.|||For more details, visit DHL.com. DHL® is a registered trademark of DHL International GmbH. All rights reserved.'
    },
    {
      id: 3,
      question: 'UPS',
      answer:
        'UPS, originally founded as the American Messenger Company in Seattle in 1907 by teenagers Claude Ryan and Jim Casey, rebranded as United Parcel Service (UPS) in 1919. Today, UPS is one of the largest global shipping companies, delivering 25 million packages daily. With over 500,000 employees worldwide, UPS serves more than 220 countries and territories, offering unmatched global reach.|||Disclaimer:|||This page was last updated in September 2024 for reference purposes only. UPS makes no warranties regarding the accuracy of the information provided.|||For more details, visit UPS.com. UPS® is a registered trademark of UPS Inc. All rights reserved.'
    }
  ]
}
